<template>
  <div id="app" :class="{ 'iframe': iframe }">
    <GlobalLoader :visible="busy" />
    <template v-if="layout != 'empty'">
      <NavBarDeploy v-if="isDeployedApp" ref="navBar" :class="{ 'wide': collapsedMenu }" :collapsed="collapsedMenu" />
      <NavBar v-else ref="navBar" :class="{ 'wide': collapsedMenu }" :collapsed="collapsedMenu" />
    </template>
    <div class="d-flex flex-column flex-lg-row" :class="{ 'h-100': layout == 'empty' }">
      <template v-if="layout != 'empty'">
        <SidebarMenu ref="sidebarMenu" @onCollapse="onCollapseSidebar" v-if="!isDeployedApp" />
        <MessengerHeader />
        <div class="flex-grow-1 d-flex flex-column w-100">
          <div :class="{ 'd-flex': layout == 'default' }">
            <div class="flex-grow-1">
              <router-view class="full-height" ref="routerView"></router-view>
            </div>
            <SideBar ref="sideBar" v-if="layout == 'default' && !isDeployedApp" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex-grow-1">
          <router-view class="h-100" ref="routerView"></router-view>
        </div>
      </template>
    </div>
    <FileUploader ref="fileUploader"/>
    <ImageViewer ref="imageViewer" />
    <PreferencesModal ref="preferencesModal" />
    <EditModelModal :modelId="editingModel" ref="editModelModal" />
  </div>
</template>

<script>
  import MessengerHeader from '@/components/messenger/messenger-header';
  import SideBar from '@/components/sidebar/sidebar';
  import SidebarMenu from '@/components/navigation/sidebar-menu';
  import FileUploader from '@/components/uploader/file-uploader'
  import NavBar from '@/components/navigation/nav-bar'
  import NavBarDeploy from '@/components/navigation/nav-bar-deploy';
  import GlobalLoader from '@/components/global-loader';
  import ImageViewer from '@/components/image-viewer'
  import socketio from 'socket.io-client';
  import config from '@/api-services/_config';
  import AuthService from './api-services/auth.service';
  import DeployService from './api-services/deploy.service';
  import Eruda from 'eruda';
  import PreferencesModal from '@/modals/preferences'
  import EditModelModal from '@/components/models/edit-model';
  import WhitelLabel from './api-services/whitelabel.service';
  import ChatbotService from './api-services/chatbot.service';

  import { EventBus } from "@/main";
  import Vue from 'vue';

  export default {
    name: 'App',
    components: {
      NavBarDeploy,
      MessengerHeader,
      SideBar,
      SidebarMenu,
      FileUploader,
      NavBar,
      GlobalLoader,
      ImageViewer,
      PreferencesModal,
      EditModelModal
    },
    data() {
      return {
      dragover: false,
      busy: false,
      nodeUrl: process.env.VUE_APP_NODE_URL || 'https://chat.ezai.io', // socket.io path is routed to node from haproxy
      theme: localStorage.getItem('theme'),
      socket: null,
      collapsedMenu: localStorage.getItem('collapsedMenu') == 'true' ? true : false,
      deployObject: null,
      editingModel: null,
      actualRoute: '',
      }
    },
    computed: {
      layout() {
        return this.$route.meta.layout || 'default';
      },
      fileUploader() {
        return this.$refs.fileUploader;
      },
      isDeployedApp() {
        return config.isDeployedApp;
      },
      iframe() {
        return window.self !== window.top;
      },
      rooms() {
        return this.$store.state.rooms;
      }
    },
    async created() {
      this.addPrototypes();
      if(!this.rooms) {
        await this.$store.dispatch('getAllRooms', this.searchQuery);
      }

      const connectSocket = () => {
        this.socket = socketio(this.nodeUrl, { auth: { token: config.sessionValue } });
      };

      const reconnectSocket = () => {
        setTimeout(() => {
          if(this.socket.io.readyState === 'pending') {
            this.socket.io.close();
            connectSocket();
            reconnectSocket();
          }
        }, 5000);
      };

      connectSocket();
      reconnectSocket();

      this.$router.beforeEach(async (to, from, next) => {
        if(this.$refs.navBar && !this.isDeployedApp) {
          this.$refs.navBar.collapse();
        }
        next();
      });
    },
    async mounted() {
      this.busy = false;
      window.addEventListener('contextmenu', e => e.preventDefault(), false);
      this.selectTheme(this.theme);
      if(this.isDeployedApp) {
        if(config.sessionValue) {
          await this.checkSession();
        }
        await this.setDeployment();
        this.pingInteraction();
      } else {
        await this.checkSession();
      }
      //this.wearOffIntruders();
      if(this.$route.query.eruda == 'true') {
        Eruda.init();
      }

      this.checkWhiteLabel();
    },
    methods: {
      editModel(id) {
        this.editingModel = id;
        this.$refs.editModelModal.show();
      },
      addPrototypes() {
        Vue.prototype.$toast = (h, i) => this.$swal({ toast: true, position: 'top', icon: i || 'success', html: h, showConfirmButton: false, timer: 3000 });
        Vue.prototype.$parseDuration = (d) => {
          if(!d) return;
          let h = Math.floor(d / 3600), m = Math.floor((d % 3600) / 60), s = d % 60;
          return h > 0 ? `${h}:${m} hrs` : m > 0 ? `${m}:${s} mins` : `${s} secs`;
        };
      },
      wearOffIntruders() {
        let intervalId;
        let index = 0;
        const warningMessages = [
          `🚨 Hey! This is a restricted area! 🚨`,
          `👀 You're not supposed to be here! 👀`,
          `🔒 Access denied! 🔒`,
          `🙅‍♀️ Stop right there, intruder! 🙅‍♂️`,
          `🤖 Beep boop, unauthorized access detected! 🤖`,
          `🚨 I mean this is an A.I software... Did you think I wasn't going to notice?? 👀`,
          `✉️ Why don't you email us at contact@ezai.io and join our team if your this good!! 🚀`
        ];

        function startWarningMessages() {
          intervalId = setInterval(() => {
          index = (index + 1) % warningMessages.length;
          if(index === warningMessages.length) {
            stopWarningMessages();
          }
          }, 6000);
        }

        function stopWarningMessages() {
          clearInterval(intervalId);
        }
        startWarningMessages();
      },
      async setDeployment() {
        const response = await DeployService.getDeployment({deploy_key: config.deployKey});
        if(response.success == 0) {
          this.$swal('', response.error, 'error');
          return;
        }

        let deployment = response.deployment;
        if(deployment.settings && deployment.settings !== ''){
          deployment.settings = JSON.parse(deployment.settings);
        }
        
        EventBus.$emit('addDeployment', deployment);
        config.setDeploymentObject(deployment);
        this.deployObject = deployment;
      },
      async checkDeploySession() {
        const response = await DeployService.checkSession();
        if(response.success == 0) {
          document.cookie = "ezai_auth_session_cookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location = config.urlAuth;
        }
      },
      onCollapseSidebar(collapsed) {
        this.collapsedMenu = collapsed;
      },
      extractCodeBlocks(data) {
        // Regex to match code blocks and capture text outside them
        const regex = /(```|``````)[\s\S]*?\1|([^`]+)/g;
        //const regex = /(```[\s\S]+?```)|([^`]+)/g;

      // Replace the fancy quotes with regular ones to avoid syntax errors
        let matches;
        const codeBlocks = [];

        while ((matches = regex.exec(data)) !== null) {
          // Determine if it's a code block or text
          const type = matches[1] ? 'code' : 'text';
          // Use the appropriate content based on the type
          const content = type === 'code' ? matches[0] : matches[2];

          // Create the template object for the block
          const template = {
            id: codeBlocks.length, // Assign unique ID based on length
            type: type, // Set the type (code or text)
            content: content, // Set the content
          };
          // Push the template object to the codeBlocks array
          codeBlocks.push(template);
        }
        // Return the array of code and text blocks
        return codeBlocks;
      },
      showDetailsTab(event_id) {
        this.$refs.sideBar.showDetailsTab(event_id);
      },
      async checkSession() {
        const response = await AuthService.checkSession();
        if(response.success == 0) {
          document.cookie = "ezai_auth_session_cookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          const publicUrls = ['/public/pricing']
          if (publicUrls.includes(this.actualRoute)) {
            return;
          }
          window.location = config.urlAuth;
        }
        this.$store.state.member = response.member;
      },
      async checkWhiteLabel() {
        const response = await WhitelLabel.checklabel();
        if(!response.exists)
          this.$store.commit('updateWhiteLabel', true);
      },
      selectTheme(theme) {
        this.theme = theme;
        const html = document.documentElement;
        html.classList.add('adding-theme');
        html.className = html.className.split(' ').filter(c => c.lastIndexOf('theme', 0) !== 0).join(' ').trim();
        localStorage.setItem('theme', theme);
        html.classList.add(localStorage.getItem('theme'));
        setTimeout(() => html.classList.remove('adding-theme'), 1000);
      },
      async addPreview(code) {
        return await this.$refs.sideBar.addPreview(code);
      },
      dontScroll(mobile = false) {
        document.getElementsByTagName('html')[0].classList.add(mobile ? 'no-scroll-mobile' : 'no-scroll');
      },
      scroll() {
        document.getElementsByTagName('html')[0].classList.remove('no-scroll', 'no-scroll-mobile');
      },
      pingInteraction() {
        let url = `https://${config.deployKey}.app.ezai.io/?token=${config.deployKey}`;
        ChatbotService.pingInteraction({url, deploy_key: config.deployKey});
        return;
      }
    },
    watch: {
      '$route.path'(newPath) {
        this.actualRoute = newPath;
        this.checkSession();
      }
    }
  }
</script>

<style lang="scss">
  @import '@/assets/scss/app.scss';
  #app {
    height: calc(var(--vh, 1vh) * 100);
    .full-height {
      height: calc(var(--vh, 1vh) * 100 - 62px);
      overflow: auto;
    }
    @media (max-width: 991px) {
      .mainContent {
        margin-top: 68px;
      }
    }

    &.iframe {
      .deploy-logo {
        max-height: 26px;
      }
    }
  }
</style>
